/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum NotificationDateFormat {
  LONG="LONG",
ISO="ISO",
EUROPEAN="EUROPEAN"
}

/**
* NotificationDateFormat
*/
export const NotificationDateFormatEnumType = types.enumeration("NotificationDateFormat", [
        "LONG",
  "ISO",
  "EUROPEAN",
      ])
